export default "__VITE_ASSET__Dk5PHMun__"